module.exports = __webpack_public_path__ + "img/thumbnail_StripedSkunk_j_albino.bb0b4449.png";